import { render, staticRenderFns } from "./EventCohostModal.vue?vue&type=template&id=71a034a4&"
import script from "./EventCohostModal.vue?vue&type=script&lang=js&"
export * from "./EventCohostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EventCohostModal.vue"
export default component.exports